import {
 
  SiPython,
  SiJavascript,
  SiReact,
  SiGit,
  SiCss3,
  SiHtml5,
  SiSqlite,
  SiBootstrap,
  SiGithub,
  SiFirebase,
} from "react-icons/si";

// Profile data constants
export const PROFILE_DATA = {
  name: "Anush Vutthuri",
  initials: "AV",
  description:
    "An enthusiastic Full Stack Developer with a strong foundation in both front-end and back-end technologies. Eager to apply my knowledge and skills to real-world projects, I am passionate about learning and growing in the field of web development.",
  resume:
    "https://drive.google.com/file/d/1mY_FoD6meeG4nlbkSRXAAwqwi1HCCoN7/view?usp=sharing",
  email: "anushv21@gmail.com",
  about: {
    profileUrl:
      "https://res.cloudinary.com/ddbxnolwi/image/upload/v1765385039/Anu1_fjhkx8_c_crop_ar_1_1_zo0fma.jpg",
    profileDescription: [
      "Hello! My name is Anush Kumar Vutthuri and I am passionate about creating interactive and responsive web applications. My interest in web development began when I started experimenting with building simple websites and applications, and it quickly grew into a full-fledged passion for coding and development.",
      "Over the years, I have honed my skills and developed a strong foundation in both front-end and back-end technologies. I love the process of bringing ideas to life on the internet and continuously strive to learn new techniques and tools to improve myself.",
      "Currently, I am focused on building efficient and scalable web applications, and I am dedicated to pushing the boundaries of what is possible in the digital world.",
    ],
  },
  education: [
    {
      name: "B.Tech - Malla Reddy College of Engineering, Hyderabad",
      duration: "Jul 2019 - Aug 2023",
      cgpa: "CGPA - 7.20",
    },
    {
      name: "Intermediate - Kshatriya Junior College, Armoor",
      duration: "Jun 2017 - Mar 2019",
      cgpa: "CGPA - 8.22",
    },
    {
      name: "SSC - Nikhil Bharat Convent High School, Metpally",
      duration: "Jun 2016 - Mar 2017",
      cgpa: "CGPA - 9.3",
    },
  ],
  skills: [
    { name: "HTML", icon: <SiHtml5 /> },
    { name: "CSS", icon: <SiCss3 /> },
    { name: "Bootstrap", icon: <SiBootstrap /> },
    // { name: "Tailwind CSS", icon: <SiTailwindcss /> },
    { name: "JavaScript", icon: <SiJavascript /> },
    { name: "React", icon: <SiReact /> },
    // { name: "Redux", icon: <SiRedux /> },
    // { name: "Node.js", icon: <SiNodedotjs /> },
    // { name: "Express", icon: <SiExpress /> },
    { name: "Python", icon: <SiPython /> },
    { name: "SQLite", icon: <SiSqlite /> },
    // { name: "MongoDB", icon: <SiMongodb /> },
    { name: "Firebase", icon: <SiFirebase /> },
    { name: "Git", icon: <SiGit /> },
    { name: "GitHub", icon: <SiGithub /> },
    // { name: "Linux", icon: <SiLinux /> },
  ],
  githubUrl: "https://api.github.com/users/ANUSHv21",
  projects: [
    {
      projectName: "Weather Application",
      imageUrl:
        "https://res.cloudinary.com/ddbxnolwi/image/upload/v1765464379/weather_hde18k_fv1kcr.webp",
      websiteUrl: "https://weather-application-anu.netlify.app//",
      githubRepoUrl: "https://github.com/ANUSHv21/Weather_App",
    },
   
    {
      projectName: "Amazon Clone",
      imageUrl:
        "https://res.cloudinary.com/ddbxnolwi/image/upload/v1765438537/Screenshot_2025-12-11_130254_fhfkyi.png",
      websiteUrl: "https://amazon-clone-av.netlify.app/",
      githubRepoUrl: "https://github.com/ANUSHv21/Amazon-Clone-Project/",
    },
    {
      projectName: "Python Patterns",
      imageUrl:
        "https://res.cloudinary.com/ddbxnolwi/image/upload/v1765441272/python-patterns_dt3iiu.webp",
      websiteUrl: "https://python-patterns-anu.netlify.app/",
      githubRepoUrl: "https://github.com/ANUSHv21/Python_patterns",
    },
    {
      projectName: "Tourism",
      imageUrl:
        "https://res.cloudinary.com/ddbxnolwi/image/upload/v1765443135/tourism_rva56s_o2roxr.webp",
      websiteUrl: "https://tourism-hyd.netlify.app/",
      githubRepoUrl:
        "https://github.com/ANUSHv21/Tourism_hyd",
    },
   
   {
      projectName: "Personal Portfolio",
      imageUrl:
        "https://res.cloudinary.com/ddbxnolwi/image/upload/v1765469306/Screenshot_2025-12-11_213651_idehqm.png",
      websiteUrl: "https://anush-vutthuri.netlify.app/",
      githubRepoUrl: "https://github.com/ANUSHv21/personal-page",
    },
    {
      projectName: "CDNJS-Clone",
      imageUrl:
        "https://res.cloudinary.com/ddbxnolwi/image/upload/v1765438536/Screenshot_2025-12-11_130416_hwo8kq.png",
      websiteUrl: "https://cdjns-clone.netlify.app/",
      githubRepoUrl: "https://github.com/ANUSHv21/CDNJS-Clone",
    },
  ],
  contact: [
    {
      name: "Github",
      socialUrl: "https://github.com/ANUSHv21",
    },
    {
      name: "LinkedIn",
      socialUrl: "https://www.linkedin.com/in/anushvutthuri/",
    },
    {
      name: "Instagram",
      socialUrl: "https://www.instagram.com/im_anoooooosh/",
    },
  ],
};
